import PropTypes from 'prop-types';
// @flow

import React, {Component} from 'react';
import _ from 'lodash';
import {Route, Redirect, Switch} from 'react-router-dom';

import Layout from 'pages/Layout';

import RoutingEnum from 'constants/RoutingEnum';

import SessionStore from 'stores/SessionStore';

import LoginPage from 'pages/login/LoginPage';
import ForgotPasswordPage from 'pages/forgotPassword';
import LogoutPage from 'pages/logout/LogoutPage';
import StatPage from 'pages/payment/stat/StatPage';
import ReceiptPage from 'pages/payment/receipt/ReceiptPage';
import OrdersListPage from 'pages/order/ordersList/OrdersListPage';
import PromotionsList from 'pages/order/cartModifiers/list/index';
import PromotionsEdit from 'pages/order/cartModifiers/edit/index';
import OrderSettingsPage from 'pages/order/settings/OrderSettingsPage';
import OrderStatisticsPage from 'pages/order/statistics/index';
import RestaurantMenuPage from 'pages/menu/RestaurantMenuPage';
import EditRestaurantPage from 'pages/restaurant/edit/EditRestaurantPage';
import NotFoundPage from 'pages/other/NotFoundPage';
import MenuDetailPage from 'pages/menu/menu/MenuDetailPage';
import MenuEditPage from 'pages/menu/menuEdit/MenuEditPage';
import ProductEditPage from 'pages/menu/productEdit/ProductEditPage';
import ProductCategoryDetailPage
  from 'pages/menu/category/ProductCategoryDetailPage';
import MenuPartEditPage from 'pages/menu/menuPartEdit/MenuPartEditPage';
import UpsellingCategoryDetailPage
  from 'pages/menu/upsellingCategories/detail/UpsellingCategoryDetailPage';
import ProductOptionDetailPage
  from 'pages/menu/option/ProductOptionDetailPage';
import ProductOptionEditPage
  from 'pages/menu/optionEdit/ProductOptionEditPage';
import DashboardPage from 'pages/dashboard/DashboardPage';
import FeatureNonActivatedPage from 'pages/other/FeatureNonActivatedPage';
import ServerErrorPage from 'pages/other/ServerErrorPage';
import CGUPage from 'pages/other/CGUPage';
import RestaurantsGroup
  from 'pages/proAccounts/restaurantsGroup/RestaurantsGroup';
import RedirectPage from 'pages/other/RedirectPage';

const routeHandlerDefinitions = [
  {
    definition: RoutingEnum.DASHBOARD,
    handler: DashboardPage
  },
  {
    definition: RoutingEnum.STAT_HOME,
    handler: StatPage
  },
  {
    definition: RoutingEnum.LOGIN,
    handler: LoginPage
  },
  {
    definition: RoutingEnum.FORGOT_PASSWORD,
    handler: ForgotPasswordPage
  },
  {
    definition: RoutingEnum.LOGOUT,
    handler: LogoutPage
  },
  {
    definition: RoutingEnum.RECEIPT,
    handler: ReceiptPage
  },
  {
    definition: RoutingEnum.ORDERS_LIST,
    handler: OrdersListPage
  },

  //
  // Menu
  //

  {
    definition: RoutingEnum.RESTAURANT_MENU,
    handler: RestaurantMenuPage
  },

  //
  // Menu - menu
  //
  {
    definition: RoutingEnum.RESTAURANT_MENU_MENU_NEW,
    handler: MenuEditPage
  },
  {
    definition: RoutingEnum.RESTAURANT_MENU_MENU_DETAIL,
    handler: MenuDetailPage
  },
  {
    definition: RoutingEnum.RESTAURANT_MENU_MENU_EDIT,
    handler: MenuEditPage
  },

  //
  // Menu - part
  //
  {
    definition: RoutingEnum.RESTAURANT_MENU_PART_EDIT,
    handler: MenuPartEditPage
  },

  //
  // Menu - product
  //

  {
    definition: RoutingEnum.RESTAURANT_MENU_PRODUCT_NEW,
    handler: ProductEditPage
  },
  {
    definition: RoutingEnum.RESTAURANT_MENU_PRODUCT_EDIT,
    handler: ProductEditPage
  },

  //
  // Menu - productOption
  //
  {
    definition: RoutingEnum.RESTAURANT_MENU_PRODUCT_OPTION_NEW,
    handler: ProductOptionEditPage
  },
  {
    definition: RoutingEnum.RESTAURANT_MENU_PRODUCT_OPTION_DETAIL,
    handler: ProductOptionDetailPage
  },
  {
    definition: RoutingEnum.RESTAURANT_MENU_PRODUCT_OPTION_EDIT,
    handler: ProductOptionEditPage,
  },

  //
  //
  //

  {
    definition: RoutingEnum.RESTAURANT_MENU_CATEGORY_DETAIL,
    handler: ProductCategoryDetailPage,
  },
  //
  //
  //

  {
    definition: RoutingEnum.RESTAURANT_MENU_UPSELLING_CATEGORY_DETAIL,
    handler: UpsellingCategoryDetailPage,
  },

  //
  // Promotions
  //
  {
    definition: RoutingEnum.ORDERS_CART_MODIFIERS_LIST,
    handler: PromotionsList
  },
  {
    definition: RoutingEnum.ORDERS_CART_MODIFIERS_NEW,
    handler: PromotionsEdit
  },
  {
    definition: RoutingEnum.ORDERS_CART_MODIFIERS_EDIT,
    handler: PromotionsEdit
  },

  //
  //
  //

  {
    definition: RoutingEnum.ORDER_STATISTICS,
    handler: OrderStatisticsPage
  },
  {
    definition: RoutingEnum.ORDER_SETTINGS,
    handler: OrderSettingsPage
  },
  {
    definition: RoutingEnum.RESTAURANT_EDIT,
    handler: EditRestaurantPage
  },
  {
    definition: RoutingEnum.FEATURE_NON_ACTIVATED,
    handler: FeatureNonActivatedPage
  },

  //
  // RestaurantsGroup
  //
  {
    definition: RoutingEnum.RESTAURANTS_GROUP,
    handler: RestaurantsGroup
  },

  //
  // Other
  //
  {
    definition: RoutingEnum.REDIRECT_PAGE,
    handler: RedirectPage
  },

  {
    definition: RoutingEnum.SERVER_ERROR,
    handler: ServerErrorPage
  },
  {
    definition: RoutingEnum.CGU,
    handler: CGUPage
  },
  {
    definition: RoutingEnum.NOT_FOUND,
    handler: NotFoundPage
  },

];

function PrivateRoute({component: Component, ...rest}) {
  return (
      <Route
          {...rest}
          render={props => {
            if (SessionStore.isLoggedIn()) {
              return <Component {...props} />;
            }
            return (
                <Redirect
                    to={{
                      pathname: '/login',
                      // Preserve query data and fragments when resuming after login.
                      state: {
                        nextLocation: {
                          pathname: props.location.pathname,
                          search: props.location.search,
                          hash: props.location.hash,
                        },
                      },
                    }}
                />
            );
          }}
      />
  );
}

// Regular pages share the layout and its account-loading lifecycle.
function AppLayoutRoutes() {
  return (
      <Layout>
        <Switch>
          {_.map(RoutingEnum, (route) => {
            if (route.disable || route === RoutingEnum.REDIRECT_PAGE) {
              return null;
            }

            let routeHandlerDefinition = routeHandlerDefinitions.find(
                r => r.definition === route)
            if (routeHandlerDefinition === undefined) {
              console.error(`No handler defined for route ${route.name}`);
              return null;
            }

            const Component = routeHandlerDefinition.handler;

            if (route.authRequired) {
              return (
                  <PrivateRoute
                      key={route.name}
                      path={route.path}
                      component={Component}
                  />
              );
            }

            return (
                <Route
                    key={route.name}
                    path={route.path}
                    component={Component}
                />
            );

          })}
        </Switch>
      </Layout>
  );
}

/**
 * Handle BOv2 redirects before mounting Layout: it loads the account using the
 * stored context and hides child routes until loading completes. RedirectPage
 * must save the incoming context first, then reload the destination.
 * Authentication is still required; all other routes use the shared layout.
 */
export default function AppRoutes() {
  return (
      <Switch>
        <PrivateRoute
            exact
            path={RoutingEnum.REDIRECT_PAGE.path}
            component={RedirectPage}
        />
        <Route component={AppLayoutRoutes} />
      </Switch>
  );
}
